const DEFAULT_SKIP = ["harborcapital.netlify.app"]

const parseList = (val) =>
  String(val || "")
    .split(/[,\s]+/)
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)

const listClient = () => {
  const env = parseList(process.env.GATSBY_TURNSTILE_SKIP_HOSTS || process.env.TURNSTILE_SKIP_HOSTS)
  return env.length ? env : DEFAULT_SKIP
}

const listServer = () => {
  const env = parseList(process.env.TURNSTILE_SKIP_HOSTS)
  return env.length ? env : DEFAULT_SKIP
}

const match = (host, patterns) => {
  const h = String(host || "").toLowerCase()
  if (!h) return false
  return patterns.some((p) => {
    if (p.startsWith("*.")) return h === p.slice(2) || h.endsWith(p.slice(1))
    return h.includes(p)
  })
}

export function shouldSkipTurnstileOnClient() {
  if (typeof window === "undefined") return false
  const host = window.location?.hostname || ""
  return match(host, listClient())
}

export function shouldSkipTurnstileFromRequest(req) {
  const headers = req?.headers || {}
  const raw =
    headers["x-forwarded-host"] ||
    headers["host"] ||
    ""
  let host = String(raw).split(",")[0].trim()
  if (!host && headers.referer) {
    try { host = new URL(headers.referer).hostname } catch { /* error */ }
  }
  if (!host && headers.origin) {
    try { host = new URL(headers.origin).hostname } catch { /* error */ }
  }
  if (host.includes(":")) host = host.split(":")[0]
  return match(host, listServer())
}

export function getClientIp(req) {
  return (
    req?.headers?.["cf-connecting-ip"] ||
    (req?.headers?.["x-forwarded-for"] || "").split(",")[0] ||
    req?.socket?.remoteAddress ||
    undefined
  )
}

export function shouldBypassTurnstile(req, body) {
  return shouldSkipTurnstileFromRequest(req) || body?.turnstileBypassed === true
}

export async function verifyTurnstileToken(
  token,
  {
    secret = process.env.TURNSTILE_SECRET || process.env.RECAPTCHA_SECRET,
    remoteip,
    expectedHostname = process.env.TURNSTILE_EXPECTED_HOSTNAME,
    expectedAction = process.env.TURNSTILE_EXPECTED_ACTION,
  } = {}
) {
  if (!token) return { ok: false, code: "missing_token" }
  if (!secret) return { ok: false, code: "missing_server_secret" }

  let resp
  try {
    const body = new URLSearchParams()
    body.append("secret", secret)
    body.append("response", token)
    if (remoteip) body.append("remoteip", remoteip)

    resp = await fetch("https://challenges.cloudflare.com/turnstile/v0/siteverify", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    })
  } catch (e) {
    return { ok: false, code: "verify_network_error", errors: [e?.message || "network"] }
  }

  let result
  try {
    result = await resp.json()
  } catch {
    return { ok: false, code: "verify_parse_error" }
  }

  if (!result?.success) {
    return { ok: false, code: result["error-codes"]?.[0] || "turnstile_failed", errors: result["error-codes"] || [], result }
  }

  if (expectedHostname && result.hostname && result.hostname !== expectedHostname) {
    return {
      ok: false,
      code: "hostname_mismatch",
      errors: [`expected:${expectedHostname}`, `got:${result.hostname}`],
      result,
    }
  }

  if (expectedAction && result.action && result.action !== expectedAction) {
    return {
      ok: false,
      code: "action_mismatch",
      errors: [`expected:${expectedAction}`, `got:${result.action}`],
      result,
    }
  }

  return { ok: true, code: "ok", result }
}
